// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoArrReloadOutlinedSvg from "@fishx/icons-svg/es/asn/PtoArrReloadOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoArrReloadOutlined = function PtoArrReloadOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoArrReloadOutlinedSvg
  }));
};

PtoArrReloadOutlined.displayName = 'PtoArrReloadOutlined';
export default React.forwardRef(PtoArrReloadOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoArrReloadOutlined.js
// module id = 3876
// module chunks = 0